import {useTranslation} from 'react-i18next';
import {useMatch} from 'react-router-dom';
import {DEVICE, useScreenResize} from '@chekin/guestapp-ui-kit';
import Page, {PageProps} from '../../components/Page';
import {AutoFillText} from './views/MRZStartView/styled';

type MRZPageLayoutProps = PageProps;
function MRZPageLayout({children, ...props}: MRZPageLayoutProps) {
  const {isMatch: isMobileMode} = useScreenResize(DEVICE.laptop);
  const isMrzTakeView = useMatch('/:token/document-mrz/take');
  const {t} = useTranslation();
  const isUploadDocumentView = useMatch('/:token/document-mrz/upload');
  const pageTitle =
    Boolean(isUploadDocumentView) && isMobileMode
      ? 'scan_your_document'
      : 'auto_fill_form';
  const isSubHeaderVisible = (Boolean(isMrzTakeView) && !isMobileMode) || !isMrzTakeView;

  return (
    <Page
      isSubHeaderVisible={isSubHeaderVisible}
      isBackButtonDisabled={isMobileMode}
      className="mrz-layout"
      {...props}
    >
      <AutoFillText className="mrz-layout__autofill-text">{t(pageTitle)}</AutoFillText>
      {children}
    </Page>
  );
}

export default MRZPageLayout;
